/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.calls.rpc.CallsCheckTranscriptChirpService
 */

export const getTranscriptionStatusRpc = {
  serviceName: 'com.hubspot.calls.rpc.CallsCheckTranscriptChirpService',
  rpcName: 'getTranscriptionStatus',
  auth: 'app',
  fingerprint: 'K9FIYKYLmjBpugeNhGjtmhuN-yXh1ZOK',
  na1Only: false,
  isStreaming: false
};